import * as React from 'react';
import { Box, Loader, Text, TextButton } from 'wix-style-react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getIsEnforceContributorsEnabled, getIsEnforceContributorsFreePlan,
  getContributorLimit,
} from '../../redux/selectors/teamDetails';
import { getNumberOfContributors } from '../../redux/selectors/teamMembers';
import { InjectedTranslateProps } from 'react-i18next';
import { getMsid } from '../../redux/selectors/config';
import { generateUpgradeLink } from '../../consts/external-links';
import * as s from './EnforceContributors.scss';
import { reportUpgradeButtonClick } from '../../redux/actions/bi.actions';

const getEnforceContributorsTextKey = (maxNumberOfContributors, enforceContributorsTextKey) => {
  if (!maxNumberOfContributors) {
    return 'upgrade_enforceContributors.unlimitedPlan.text';
  } else if (enforceContributorsTextKey) {
    return 'upgrade_enforceContributors.freePlan.text';
  } else {
    return 'upgrade_enforceContributors.plan.text';
  }
};

export const EnforceContributorsTableText: React.FC<InjectedTranslateProps> = ({ t }) => {
  const dispatch = useDispatch();
  const isEnforceContributorsEnabled = useSelector(getIsEnforceContributorsEnabled);
  const contributorLimit = useSelector(getContributorLimit);
  const isEnforceContributorsFreePlan = useSelector(getIsEnforceContributorsFreePlan);
  const msid = useSelector(getMsid);

  const onUpgradeClick = () => dispatch(reportUpgradeButtonClick('/'));

  if (!isEnforceContributorsEnabled) {
    return null;
  }

  return (<Box className={s.EnforceContributors}>
      <Text size="small">{t(getEnforceContributorsTextKey(contributorLimit, isEnforceContributorsFreePlan), { numOfContributors: contributorLimit })}</Text>
      { contributorLimit &&
      <TextButton size="small" skin="premium" as="a" href={generateUpgradeLink(msid)} target="_blank" onClick={onUpgradeClick}>
        {t('upgrade_enforceContributors.upgradeYourPlan')}
      </TextButton> }
    </Box>);
};

export const EnforceContributorsInviteText: React.FC<InjectedTranslateProps & { numberOfEmails: number }>  = ({ t, numberOfEmails }) => {
  const dispatch = useDispatch();
  const isEnforceContributorsEnabled = useSelector(getIsEnforceContributorsEnabled);
  const contributorLimit = useSelector(getContributorLimit);
  const numberOfContributors = useSelector(getNumberOfContributors) + numberOfEmails;
  const msid = useSelector(getMsid);

  const onUpgradeClick = () => dispatch(reportUpgradeButtonClick('/invite'));

  if (!isEnforceContributorsEnabled) {
    return null;
  }

  return (<Box className={s.EnforceContributors}>
    <Text>{t('upgrade_enforceContributors.invitesUsed', { contributors: `${numberOfContributors}/${contributorLimit}` })}</Text>
    { (contributorLimit - numberOfContributors < 2) &&  <TextButton skin="premium" as="a" href={generateUpgradeLink(msid)} target="_blank" onClick={onUpgradeClick}>
        {t('upgrade_enforceContributors.upgradeForMore')}
      </TextButton> }
  </Box>
  );
};

export const EnforceContributorsButtonLoading = ({ isLoading, text }) => {
  const isEnforceContributorsEnabled = useSelector(getIsEnforceContributorsEnabled);

  if (!isEnforceContributorsEnabled) {
    return text;
  }

  return (<>
    <span style={{ position: 'absolute', display: isLoading ? 'grid' : 'none', left: 0, right: 0 }}><Loader size="tiny" /></span>
    <span style={{ visibility: isLoading ? 'hidden' : 'initial' }}> {text} </span>
  </>);
};
